import React, { useState } from "react";
import './header.css'

import whats from '../img/whats.png'

function Header() {
    return (
        <div className="containerHeader">
            <div className="anuncio-1">
                <h1>BLACK</h1>
                <h1>DAS BLACKS</h1>
            </div>

            <a href="https://api.whatsapp.com/send?text=[https://catalago.netlify.app/]" target='_blank' className="anuncio-2">
                <img src={whats} />
                <p>Compartilhe essas ofertas</p>
                <p>com todos os seus amigos</p>
            </a>

        </div>
    )


}

export default Header;